var navtimeoutid = null;
var boolworking = false;
function ToggleMenu(menuid)
{
    $('.newmainnav').each( function( index ) {
		// check whether this one is currently visible
		// if it is we will need to hide it first
		if( this.id != menuid && $(this).is(':visible') )
		{
			$(this).slideUp(400, function() {
				ShowMenu(menuid);
			});
			return false;
		}
	});
	ShowMenu(menuid);
	if( navtimeoutid != null ) window.clearTimeout(navtimeoutid);
}
function MenuOut()
{
	navtimeoutid = window.setTimeout(HideMenus, 1000);
}


function ShowMenu(menuid)
{
	if($('#' + menuid).length > 0 ){
		if( !$('#' + menuid).is(':visible') ) {
			$('#' + menuid).slideDown();
		}
	} 
}

function HideMenus()
{
	$('.newmainnav').each( function( index ) {
		// check whether this one is currently visible
		// if it is we will need to hide it first
		if( $(this).is(':visible') )
		{
			$(this).slideUp();
		}
	});
}